$('.module__share_header a.action').on('click', function(e) {
    
    e.preventDefault();

    var network = e.toElement.dataset.network;
    var link = e.toElement.dataset.url;
    var title = e.toElement.dataset.title;
    var winTop = ($(window).height() / 2) - (770 / 2);
    var winLeft = ($(window).width() / 2) - (600 / 2);

    switch (network) {

        case 'facebook':

            window.open('http://www.facebook.com/sharer.php?u='+link+'&display=popup', "", 'width=770,height=600,top='+winTop+',left='+winLeft+',toolbar=0,personalbar=0,menubar=no,location=no,directories=no,status');

            break;
    
        case 'twitter' :

            window.open('http://twitter.com/intent/tweet?text='+title+'%0D%0A&url='+link, "", 'width=770,height=600,top='+winTop+',left='+winLeft+',toolbar=0,personalbar=0,menubar=no,location=no,directories=no,status');
            
            break;

        case 'link' : 

            // Create a temporary input element
            var $temp = $("<input>");
            $("body").append($temp);
            $temp.val(link).select();

            try {
                document.execCommand('copy');
                alert("Le lien URL a été copié sur votre presse-papiers.");
                $temp.remove();
                
            } catch(err) {
                console.log('Oops, unable to copy' + err);
            }

            break;

        default:

            break;
    }
});  